module.exports = __webpack_public_path__ + "static/media/error.3a71f825.png";